import React, { FC } from "react";
import Image from "next/image";
import getConfig from "next/config";
import { getCloudflareLoader } from "../../../../../helpers/cloudflareImages";
import { StyledImageDetail } from "./index.styled";

const { publicRuntimeConfig } = getConfig();

interface ImageDetailProps {
  round?: boolean;
  value: string;
}

export const ImageDetail: FC<ImageDetailProps> = ({ round = false, value }) => (
  <StyledImageDetail round={round}>
    <Image
      src={value}
      alt="customization image"
      loader={getCloudflareLoader(publicRuntimeConfig.productsImgCdn)}
      fill
      // double largest width for retina screens
      sizes="24px"
      style={{
        objectFit: "contain",
      }}
    />
  </StyledImageDetail>
);
